import { axios } from "../../helpers/axios";
import {
    CHANGE_PASSWORD_URL,
    COMPANY_URL,
    FORGOT_PASSWORD_REQUEST_URL,
    GET_COMPANY_DETAILS,
    GET_USER_COMPANY_LIST_URL,
    PROCESS_URL,
    REGISTER_URL,
    RESET_PASSWORD_URL,
    STAGE_URL
} from "./userConstants";

// Move to users store

export const api_forgot_password_request_url = async (data) => {
    return axios.post(FORGOT_PASSWORD_REQUEST_URL, data);
};
export const api_register_url = async (data) => {
    return axios.post(REGISTER_URL, data);
};

export const api_reset_password_url = async (data,token) => {
    return axios.patch(RESET_PASSWORD_URL, data,{headers:{
        'Authorization': 'Bearer ' + token,
    }});
};

export const api_get_company_process_url = async (company_id) => {
    return axios.get(COMPANY_URL + '/' + company_id + PROCESS_URL);
};

export const api_get_company_process_stage_url = async (company_id,process_id) => {
    return axios.get(COMPANY_URL + '/' + company_id + STAGE_URL + '/' + process_id);
};

export const api_get_user_company_url = async () => {
    return axios.get(GET_USER_COMPANY_LIST_URL);
};

export const api_change_password_url = async (data) => {
    return axios.patch(CHANGE_PASSWORD_URL,data);
};

export const api_get_company_details_by_domain_url = async (company_domain) => {
    return axios.get(COMPANY_URL + '/' + company_domain + GET_COMPANY_DETAILS);
};

export const api_get_company_users_list = async (company_id) => {
    return axios.get(COMPANY_URL + '/' + company_id + '/user');
};
